import { getComposedFieldName } from '@packlink/utils';
import { useFormikContext, getIn } from 'formik';
import React, { useContext } from 'react';

const CustomsFormContext = /*#__PURE__*/React.createContext({
  validTariffNumbers: [],
  locale: '',
  tariffNumberLink: ''
});
function useCustomsFormContext() {
  return useContext(CustomsFormContext);
}
function useCustomsFormData() {
  const {
    fieldNamePrefix
  } = useCustomsFormContext();
  const {
    touched: formTouched,
    errors: formErrors,
    values: formValues,
    initialTouched,
    initialValues,
    initialErrors,
    ...otherFormikProps
  } = useFormikContext();
  const formAccessKey = getComposedFieldName(fieldNamePrefix);
  return {
    values: getIn(formValues, formAccessKey),
    touched: getIn(formTouched, formAccessKey) || {},
    errors: getIn(formErrors, formAccessKey) || {},
    initialValues: getIn(initialValues, formAccessKey),
    initialTouched: getIn(initialTouched, formAccessKey) || {},
    initialErrors: getIn(initialErrors, formAccessKey) || {},
    ...otherFormikProps
  };
}

export { CustomsFormContext, useCustomsFormContext, useCustomsFormData };
//# sourceMappingURL=CustomsFormData.js.map
